import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import {
  actionHandler,
  changeFocusOnMaxLength,
} from '../../../utilities/form/formUtils';

// Components
import Label from '../../Form/Label';
import Description from '../../Form/Description';
import Error from '../../Form/Error';

class TextArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: Object.hasOwnProperty.call(props.values, props.id) ? props.values[props.id] : '',
    };

    this.handleTextChange = this.handleTextChange.bind(this);
  }

  handleTextChange(event) {
    const {
      onChange,
      onBlur,
      maxLength,
      formValues,
      formValuesTemplate,
      actions,
      dispatch,
      values,
      setValues,
    } = this.props;
    const { target: { value } } = event;

    // Forces onBlur to save data, when value.length is equal to it's maxLength
    if (maxLength && value.length === Number(maxLength)) {
      onBlur(event, formValues, formValuesTemplate);
    }

    this.setState({
      value,
    });

    // Handle actions on input.
    if (actions.length > 0) {
      actionHandler(actions, onChange, event, dispatch, values, setValues);
    } else {
      onChange(event);
    }
  }

  render() {
    const {
      id,
      desc,
      label,
      errors,
      touched,
      columns,
      mobileColumns,
      isLoading,
      hidden,
    } = this.props;
    const { value } = this.state;
    if (hidden) {
      return null;
    }

    const formFieldClass = classNames(
      'form__field',
      'form__field--textfield', {
        'form__field--no-label': !label,
        [`form__field--${id}`]: id,
        [`form__field--${columns}col`]: columns,
        [`form__field--mobile-${mobileColumns}col`]: mobileColumns,
      },
      isLoading
    );

    return (
      <div className={formFieldClass}>

        {/* Label */}
        {label &&
          <Label id={id} label={label} />
        }

        {/* Input Field */}
        <textarea rows="4" cols="50" value={value}/>

        {/* Error Message */}
        <Error touched={touched} errors={errors} id={id} />

        {/* Description */}
        {desc &&
          <Description desc={desc} />
        }
      </div>
    );
  }
}

export default TextArea;

TextArea.defaultProps = {
  desc: null,
  label: null,
  maxLength: null,
  mobileColumns: null,
  isLoading: null,
  formValues: [],
  formValuesTemplate: '',
  actions: [],
  hidden: false,
};

TextArea.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  formValues: PropTypes.array,
  formValuesTemplate: PropTypes.string,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  columns: PropTypes.string.isRequired,
  mobileColumns: PropTypes.string,
  label: PropTypes.string,
  desc: PropTypes.string,
  maxLength: PropTypes.string,
  isLoading: PropTypes.string,
  values: PropTypes.array.isRequired,
  actions: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Steps/Input/TextArea.jsx